import React from 'react';

const Section = ({ 
  children, 
  className = '',
  bgColor = 'bg-white',
  spacing = 'py-16',
  ...props 
}) => {
  return (
    <section 
      className={`${bgColor} ${spacing} ${className}`}
      {...props}
    >
      <div className="container mx-auto px-4">
        {children}
      </div>
    </section>
  );
};

export default Section;